import { atom } from "recoil";

import { CustomFieldDto } from "../../../dto/customField";

export const customFieldsAtom = atom<CustomFieldDto[] | undefined>({
  key: "customFieldsAtom",
  default: undefined,
});
